import { IAgoraRTCClient, ILocalAudioTrack, ILocalVideoTrack } from 'agora-rtc-sdk-ng';

export const leaveFromVideoCall = async (
  client: IAgoraRTCClient,
  videoTrack: ILocalVideoTrack | null,
  audioTrack: ILocalAudioTrack | null
) => {
  await client.leave();
  await client.stopProxyServer();
  await client.removeAllListeners();

  await audioTrack?.close();
  await videoTrack?.close();
};
